import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'

@observer
export default class NewRapidSurveyModal extends Component {
    constructor(props) {
        super(props)
        const { store } = this.props
        this.appStore = store
    }

    close = (e) => {
        const { onClose } = this.props
        e?.preventDefault()
        onClose()
    }

    render() {
        const { show } = this.props
        return (
            <Modal
                show={show}
                onClose={this.close}
                size="small"
            >
                <div id="new-rapid-survey-modal">
                    <div className="uc-modal__header">
                        <div className="icons-wrapper">
                            <i className="fa-light fa-align-right" />
                            <i className="fa-light fa-clipboard-list" />
                        </div>
                        <h2>{i18n.t('surveyBuilder.modal.newRapidSurvey.title')}</h2>
                        <p className="uc-modal__desc">
                            {i18n.t('surveyBuilder.modal.newRapidSurvey.desc')}
                        </p>
                    </div>
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={this.close}
                            cssClass="primary regular"
                            label={i18n.t('continue')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}
